import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-off-white flex flex-col items-center justify-center p-4">
      <div className="text-center animate-fade-in">
        {/* 404 */}
        <h1 className="text-8xl font-heading-luxury text-copper mb-4">404</h1>
        
        {/* Message */}
        <h2 className="text-2xl font-bold text-luxury-dark mb-2">
          ページが見つかりません
        </h2>
        <p className="text-neutral-600 mb-8 max-w-md">
          お探しのページは移動または削除された可能性があります。
          URLをご確認いただくか、トップページからお探しください。
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/dashboard">
            <Button leftIcon={<Home className="w-4 h-4" />}>
              ダッシュボードへ
            </Button>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 text-copper hover:underline"
          >
            <ArrowLeft className="w-4 h-4" />
            前のページに戻る
          </button>
        </div>
      </div>
    </div>
  );
}
